webpackJsonp([65745867884573],{

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBsGrid = __webpack_require__(34);
	
	var _reactBodyClassname = __webpack_require__(33);
	
	var _reactBodyClassname2 = _interopRequireDefault(_reactBodyClassname);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactFeather = __webpack_require__(75);
	
	var _element = __webpack_require__(54);
	
	var _gatsbyLink = __webpack_require__(74);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactWindowSize = __webpack_require__(53);
	
	var _reactWindowSize2 = _interopRequireDefault(_reactWindowSize);
	
	var _get = __webpack_require__(103);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactFab = __webpack_require__(105);
	
	var _Space = __webpack_require__(36);
	
	var _Space2 = _interopRequireDefault(_Space);
	
	var _Title = __webpack_require__(84);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Page = __webpack_require__(35);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _constants = __webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global graphql */
	
	
	var Element = function (_Component) {
	  _inherits(Element, _Component);
	
	  function Element() {
	    _classCallCheck(this, Element);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Element.prototype.componentDidMount = function componentDidMount() {
	    if (Prism) Prism.highlightAll();
	  };
	
	  Element.prototype.getSideLength = function getSideLength() {
	    var windowWidth = this.props.windowWidth;
	
	    var sideLength = 340;
	    if (windowWidth < 1200) sideLength = 270;
	    if (windowWidth < 992) sideLength = 210;
	    if (windowWidth < 768) sideLength = 258;
	    if (windowWidth < 570) sideLength = windowWidth - 100;
	    if (windowWidth === 0) sideLength = 340;
	    return sideLength;
	  };
	
	  Element.prototype.getDocs = function getDocs() {
	    var edges = (0, _get2.default)(this.props, 'data.allMarkdownRemark.edges');
	    if (!edges) return '';
	    var html = edges.filter(function (edge) {
	      return edge.node.html.indexOf('name="elements"') > -1;
	    })[0].node.html;
	
	    return html.slice(html.indexOf('<h2>'));
	  };
	
	  Element.prototype.scrollTo = function scrollTo(key) {
	    return function () {
	      document.querySelector('[name="elements__' + key + '"]').scrollIntoView({
	        behavior: 'smooth',
	        block: 'center',
	        inline: 'nearest'
	      });
	    };
	  };
	
	  Element.prototype.render = function render() {
	    var sideLength = this.getSideLength();
	    var height = sideLength / 3 * 2;
	    return _react2.default.createElement(
	      _reactBodyClassname2.default,
	      { className: 'no-padding' },
	      _react2.default.createElement(
	        _Page2.default,
	        { fluid: true, name: 'page-build' },
	        _react2.default.createElement(_reactHelmet2.default, {
	          title: 'Potion.js - React + D3',
	          meta: [{
	            property: 'og:url',
	            content: 'http://numberpicture.com/build'
	          }, {
	            property: 'og:title',
	            content: 'Potion.js - React + D3'
	          }, {
	            property: 'og:description',
	            content: 'Low-level React components for declaratively composing animated, interactive SVG visualizations.'
	          }, {
	            name: 'twitter:title',
	            content: 'Potion.js - React + D3'
	          }, {
	            name: 'twitter:description',
	            content: 'Low-level React components for declaratively composing animated, interactive SVG visualizations.'
	          }, {
	            charSet: 'utf-8'
	          }]
	        }),
	        _react2.default.createElement(
	          _reactFab.Fab,
	          { style: { right: '20px', bottom: '20px' } },
	          _react2.default.createElement(
	            _reactFab.FabButton,
	            null,
	            _react2.default.createElement(
	              'a',
	              { onClick: this.scrollTo('top') },
	              _react2.default.createElement(_reactFeather.ChevronUp, null)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBsGrid.Container,
	          { fluid: true },
	          _react2.default.createElement(
	            _reactBsGrid.Row,
	            null,
	            _react2.default.createElement(
	              _reactBsGrid.Container,
	              null,
	              _react2.default.createElement(
	                _reactBsGrid.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBsGrid.Col,
	                  { lg: 12 },
	                  _react2.default.createElement('div', { name: 'elements__top' }),
	                  _react2.default.createElement(
	                    _Title2.default,
	                    null,
	                    'Elements'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBsGrid.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBsGrid.Col,
	                  { lg: 8 },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Potion Elements are presentational React components that render the building blocks of visualizations. They all render SVG by default but this can be overridden using component injection. The prop names are designed to be as similar to the API of native SVG and D3 generators.'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Use these in combination with ',
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { to: '/layout' },
	                      'Potion Layouts'
	                    ),
	                    ' and other utilities to construct custom animated  visualizations from the ground up.'
	                  )
	                ),
	                _react2.default.createElement(_Space2.default, { half: true })
	              ),
	              _react2.default.createElement(
	                _reactBsGrid.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBsGrid.Col,
	                  { md: 4, sm: 6 },
	                  _react2.default.createElement(
	                    'a',
	                    { onClick: this.scrollTo('arc') },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Arc'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart' },
	                      _react2.default.createElement(
	                        _element.Svg,
	                        { width: sideLength, height: height },
	                        _react2.default.createElement(_element.Arc, {
	                          innerRadius: 0,
	                          outerRadius: height / 3,
	                          startAngle: Math.PI / 3,
	                          endAngle: Math.PI / 3 * 2,
	                          fill: _constants.COLORS.DARK_GREY,
	                          transform: {
	                            translate: [sideLength / 3, height / 2]
	                          }
	                        })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBsGrid.Col,
	                  { md: 4, sm: 6 },
	                  _react2.default.createElement(
	                    'a',
	                    { onClick: this.scrollTo('area') },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Area'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart' },
	                      _react2.default.createElement(
	                        _element.Svg,
	                        { width: sideLength, height: height },
	                        _react2.default.createElement(_element.Area, {
	                          x: function x(d) {
	                            return d.x;
	                          },
	                          y1: function y1(d) {
	                            return d.y1;
	                          },
	                          y0: height * 0.8,
	                          points: [{ x: sideLength * 0.1, y1: height * 0.2 }, { x: sideLength * 0.3, y1: height * 0.4 }, { x: sideLength * 0.4, y1: height * 0.3 }, { x: sideLength * 0.5, y1: height * 0.7 }, { x: sideLength * 0.7, y1: height * 0.4 }, { x: sideLength * 0.9, y1: height * 0.5 }],
	                          fill: _constants.COLORS.DARK_GREY
	                        })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBsGrid.Col,
	                  { md: 4, sm: 6 },
	                  _react2.default.createElement(
	                    'a',
	                    { onClick: this.scrollTo('areaRadial') },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'AreaRadial'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart' },
	                      _react2.default.createElement(
	                        _element.Svg,
	                        { width: sideLength, height: height },
	                        _react2.default.createElement(_element.AreaRadial, {
	                          angle: function angle(d) {
	                            return d.angle;
	                          },
	                          outerRadius: function outerRadius(d) {
	                            return d.outerRadius;
	                          },
	                          innerRadius: height * 0.1,
	                          points: [{ angle: 0, outerRadius: height * 0.3 }, { angle: Math.PI * 0.25, outerRadius: height * 0.2 }, { angle: Math.PI * 0.5, outerRadius: height * 0.3 }, { angle: Math.PI * 0.75, outerRadius: height * 0.2 }, { angle: Math.PI, outerRadius: height * 0.3 }, { angle: Math.PI * 1.25, outerRadius: height * 0.2 }, { angle: Math.PI * 1.5, outerRadius: height * 0.3 }, { angle: Math.PI * 1.75, outerRadius: height * 0.2 }, { angle: Math.PI * 2, outerRadius: height * 0.3 }],
	                          fill: _constants.COLORS.DARK_GREY,
	                          transform: {
	                            translate: [sideLength / 2, height / 2]
	                          }
	                        })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBsGrid.Col,
	                  { md: 4, sm: 6 },
	                  _react2.default.createElement(
	                    'a',
	                    { onClick: this.scrollTo('circle') },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Circle'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart' },
	                      _react2.default.createElement(
	                        _element.Svg,
	                        { width: sideLength, height: height },
	                        _react2.default.createElement(_element.Circle, {
	                          cx: sideLength / 2,
	                          cy: height / 2,
	                          r: 50,
	                          fill: _constants.COLORS.DARK_GREY
	                        })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBsGrid.Col,
	                  { md: 4, sm: 6 },
	                  _react2.default.createElement(
	                    'a',
	                    { onClick: this.scrollTo('line') },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Line'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart' },
	                      _react2.default.createElement(
	                        _element.Svg,
	                        { width: sideLength, height: height },
	                        _react2.default.createElement(_element.Line, {
	                          x1: sideLength / 3,
	                          y1: height / 3,
	                          x2: sideLength / 3 * 2,
	                          y2: height / 3 * 2,
	                          stroke: _constants.COLORS.DARK_GREY,
	                          strokeWidth: 4
	                        })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBsGrid.Col,
	                  { md: 4, sm: 6 },
	                  _react2.default.createElement(
	                    'a',
	                    { onClick: this.scrollTo('lineRadial') },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'LineRadial'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart' },
	                      _react2.default.createElement(
	                        _element.Svg,
	                        { width: sideLength, height: height },
	                        _react2.default.createElement(_element.LineRadial, {
	                          fill: 'none',
	                          stroke: _constants.COLORS.DARK_GREY,
	                          points: [[0, 50], [Math.PI * 0.25, 50], [Math.PI * 0.5, 50], [Math.PI * 0.75, 50], [Math.PI, 50], [Math.PI * 1.25, 50], [Math.PI * 1.5, 50], [Math.PI * 1.75, 50], [Math.PI * 2, 50]],
	                          strokeWidth: 4,
	                          transform: {
	                            translate: [sideLength / 2, height / 2]
	                          }
	                        })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBsGrid.Col,
	                  { md: 4, sm: 6 },
	                  _react2.default.createElement(
	                    'a',
	                    { onClick: this.scrollTo('rect') },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Rect'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart' },
	                      _react2.default.createElement(
	                        _element.Svg,
	                        { width: sideLength, height: height },
	                        _react2.default.createElement(_element.Rect, {
	                          x: sideLength / 3,
	                          y: height / 3,
	                          width: sideLength / 3,
	                          height: height / 3,
	                          fill: _constants.COLORS.DARK_GREY
	                        })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBsGrid.Col,
	                  { md: 4, sm: 6 },
	                  _react2.default.createElement(
	                    'a',
	                    { onClick: this.scrollTo('ribbon') },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Ribbon'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart' },
	                      _react2.default.createElement(
	                        _element.Svg,
	                        { width: sideLength, height: height },
	                        _react2.default.createElement(_element.Ribbon, {
	                          source: {
	                            startAngle: 0.7524114,
	                            endAngle: 1.1212972,
	                            radius: height * 0.4
	                          },
	                          target: {
	                            startAngle: 1.8617078,
	                            endAngle: 1.9842927,
	                            radius: height * 0.4
	                          },
	                          fill: _constants.COLORS.DARK_GREY,
	                          transform: {
	                            translate: [sideLength / 3, height / 2]
	                          }
	                        })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBsGrid.Col,
	                  { md: 4, sm: 6 },
	                  _react2.default.createElement(
	                    'a',
	                    { onClick: this.scrollTo('symbolShape') },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'SymbolShape'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart' },
	                      _react2.default.createElement(
	                        _element.Svg,
	                        { width: sideLength, height: height },
	                        _react2.default.createElement(_element.SymbolShape, {
	                          type: 'symbolCross',
	                          fill: _constants.COLORS.DARK_GREY,
	                          size: 2000,
	                          transform: {
	                            translate: [sideLength / 2, height / 2]
	                          }
	                        })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBsGrid.Col,
	                  { md: 4, sm: 6 },
	                  _react2.default.createElement(
	                    'a',
	                    { onClick: this.scrollTo('text') },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Text'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart' },
	                      _react2.default.createElement(
	                        _element.Svg,
	                        { width: sideLength, height: height },
	                        _react2.default.createElement(
	                          _element.Text,
	                          {
	                            dx: sideLength / 2,
	                            dy: height / 2,
	                            fill: _constants.COLORS.DARK_GREY,
	                            fontSize: 30,
	                            textAnchor: 'middle',
	                            alignmentBaseline: 'middle'
	                          },
	                          'Lorem ipsum'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'page page-docs' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'content' },
	                  _react2.default.createElement('div', {
	                    dangerouslySetInnerHTML: {
	                      __html: this.getDocs()
	                    }
	                  })
	                )
	              ),
	              _react2.default.createElement(_Space2.default, null),
	              _react2.default.createElement(_Space2.default, null)
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Element;
	}(_react.Component);
	
	exports.default = (0, _reactWindowSize2.default)(Element);
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-element-js-0e7d8e2f1c10a7192426.js